<template>
  <mdb-container>
    <!--Navbar-->
    <mdb-navbar dark v-if="!loading" position="top" class="z-depth-3" scrolling>
      <!-- Navbar brand -->
      <mdb-navbar-brand>
        <router-link to="/">
          <img :src="require('@/assets/seal.png')" height="45" alt />
        </router-link>
      </mdb-navbar-brand>

      <mdb-navbar-toggler>
        <mdb-navbar-nav left>
          <mdb-dropdown
            v-for="top_items in menu.items"
            :key="top_items.id"
            tag="li"
            megaMenu
            class="nav-item"
          >
            <mdb-dropdown-toggle
              slot="toggle"
              class="text-uppercase"
              tag="a"
              transparent
              navLink
              waves-fixed
            >{{top_items.title}}</mdb-dropdown-toggle>
            <mdb-dropdown-menu class="mega-menu v-2 z-depth-1 py-5 px-3">
              <div class="row">
                <div
                  v-for="headings in top_items.menu_heading"
                  :key="headings.id"
                  class="col-md-6 col-xl-3 sub-menu mb-xl-0 mb-4"
                >
                  <h6 v-if="headings.link_type == 'slug'" class="sub-title">
                    <router-link
                      tag="a"
                      class="text-uppercase font-weight-bold white-text"
                      :to="'/'+headings.component + '/' +headings.slug"
                    >{{headings.title}}</router-link>
                  </h6>
                  <h6
                    v-else
                    class="sub-title text-uppercase font-weight-bold white-text"
                  >{{headings.title}}</h6>
                  <ul class="list-unstyled">
                    <li v-for="links in headings.menu_items" :key="links.id">
                      <router-link
                        tag="a"
                        class="menu-item pl-0"
                        :to="'/'+links.component + '/' +links.slug"
                      >
                        <i class="fas fa-caret-right pl-1 pr-3 d-inline-block"></i>
                        {{links.title}}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </mdb-dropdown-menu>
          </mdb-dropdown>

          <!--Hard coded dropdown for calendar b/c it is not user controlled.-->

          <mdb-dropdown tag="li" megaMenu class="nav-item">
            <mdb-dropdown-toggle
              slot="toggle"
              class="text-uppercase"
              tag="a"
              transparent
              navLink
              waves-fixed
            >Calendar</mdb-dropdown-toggle>
            <mdb-dropdown-menu class="mega-menu v-2 z-depth-1 py-5 px-3">
              <div class="row">
                <div class="col-md-6 col-xl-3 sub-menu mb-xl-0 mb-4">
                  <h6 class="sub-title">
                    <router-link
                      class="text-uppercase font-weight-bold white-text"
                      :to="`/calendar`"
                    >Calendar</router-link>
                  </h6>
                  <ul class="list-unstyled">
                    <li>
                      <router-link class="menu-item pl-0" :to="`/calendar`">
                        <i class="fas fa-caret-right pl-1 pr-3 d-inline-block"></i>
                        Calendar
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </mdb-dropdown-menu>
          </mdb-dropdown>
        </mdb-navbar-nav>
      </mdb-navbar-toggler>
    </mdb-navbar>
  </mdb-container>
  <!--/.Navbar-->
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbContainer,
} from "mdbvue";

import axios from "axios";
import api from "@/api";

export default {
  name: "HomeAppBar",

  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbContainer,
  },

  data: () => ({
    menu: null,
    loading: true,
  }),
  mounted() {
    axios;
    api
      .get("menu/")
      .then((response) => {
        this.menu = response.data;
        this.loading = false;
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>
